import { createSlice } from "@reduxjs/toolkit";
import { State } from "store/state";
import { cloneDeep, filter } from "lodash";
import {
  ImportableProduct,
  ProductsValidationResult,
} from "ts/app/productsBulkUpload";
import {
  ProductCsvUploadProgress,
  ProductImportProgress,
  ProductImportStatus,
  ProductsCsvFileStatus,
} from "./helpers";

export const selectProductsValidationResult = (state: State) =>
  state.productBulkUploadStatus.productsValidationResult;

export const selectBulkUploadStatus = (state: State) =>
  state.productBulkUploadStatus;

const initialState: ProductImportStatus = {
  productImportProgress: ProductImportProgress.FILE_UPLOAD,
  csvUploadProgress: ProductCsvUploadProgress.TEMPLATE_DOWNLOAD,
  productsCsvFileStatus: "no-file-uploaded",
  productsValidationResult: null,
};

const bulkUploadSlice = createSlice({
  name: "bulkUploadStatus",
  initialState,
  reducers: {
    clear: () => cloneDeep(initialState),
    updateProductsCsvFileStatus: (
      state,
      { payload }: { payload: ProductsCsvFileStatus }
    ) => ({ ...state, productsCsvFileStatus: payload }),

    goToProductCsvFileUpload: (state) => ({
      ...state,
      productImportProgress: ProductImportProgress.FILE_UPLOAD,
      csvUploadProgress: ProductCsvUploadProgress.CSV_UPLOAD,
    }),

    goToReviewAndSubmit: (state) => ({
      ...state,
      productImportProgress: ProductImportProgress.REVIEW,
    }),

    resetProductsImportProgress: (state) => ({
      ...state,
      productImportProgress: ProductImportProgress.FILE_UPLOAD,
      csvUploadProgress: ProductCsvUploadProgress.TEMPLATE_DOWNLOAD,
      productsCsvFileStatus: "no-file-uploaded",
      productsValidationResult: null,
    }),

    updateProductsValidationResult: (
      state,
      {
        payload: productsValidationResult,
      }: { payload: ProductsValidationResult }
    ) => ({ ...state, productsValidationResult }),

    removeProductValidationResult: (
      state,
      { payload }: { payload: ImportableProduct }
    ) => {
      if (state.productsValidationResult?.products) {
        const newProductsState = filter(
          state.productsValidationResult.products,
          (product) => payload.customId !== product.customId
        );
        return {
          ...state,
          productsValidationResult: {
            ...state.productsValidationResult,
            products: newProductsState,
          },
        };
      }
      return state;
    },
  },
});

export const {
  clear,
  updateProductsCsvFileStatus,
  goToReviewAndSubmit,
  goToProductCsvFileUpload,
  resetProductsImportProgress,
  removeProductValidationResult,
  updateProductsValidationResult,
} = bulkUploadSlice.actions;
export default bulkUploadSlice.reducer;
